import { CURRENCY_CODES } from "@/constants/CountryOptions";
import { z } from "zod";
import { AD_TYPES } from "./AdTypes";
import { AD_PRICE_TYPE_KEYS } from "./AdPriceTypes";

export const AD_OFFER_DETAILS_SCHEMA = z
  .object({
    type: z.enum(AD_TYPES, "Type is required"),
    price: z.string(),
    priceType: z.enum(AD_PRICE_TYPE_KEYS, "Price type is required"),
    priceCurrency: z.enum(CURRENCY_CODES, "Currency is required"),
  })
  .refine(
    (data) => {
      if (data.priceType !== "poa" && data.priceType !== "free") {
        return Number(data.price) > 0;
      }
      return true;
    },
    {
      message: "Price must be a positive number",
      path: ["price"],
    },
  );

export const AD_DETAILS_SCHEMA = AD_OFFER_DETAILS_SCHEMA.safeExtend({
  title: z
    .string()
    .min(1, "Title is required")
    .max(50, "Title must be no more than 50 characters"),
  description: z.string().min(1, "Description is required"),
  offers: z.array(z.string()),
});

export type AdDetails = z.infer<typeof AD_DETAILS_SCHEMA>;

export type AdOfferDetails = z.infer<typeof AD_OFFER_DETAILS_SCHEMA>;

export const AD_OFFER_DETAILS_DEFAULTS: AdOfferDetails = {
  type: "sale",
  price: "",
  priceType: "amount",
  priceCurrency: "AUD",
};

export const AD_DETAILS_DEFAULTS: AdDetails = {
  ...AD_OFFER_DETAILS_DEFAULTS,
  title: "",
  description: "",
  offers: [],
};
